import { Spin } from 'antd'
import { useEffect } from 'react'
import { useApi } from '../../services/ApiContext'

export const BillingPage = () => {
  const api = useApi()

  const stripeRedirect = async () => {
    const session = await api.createBillingSession()
    window.location.replace(session.url)
  }

  useEffect(() => {
    stripeRedirect()
  }, [])

  return (
    <div className='flex justify-center items-center h-full min-h-48'>
      <Spin tip={'Loading billing centre..'} spinning={true} />
    </div>
  )
}
